/**
 * Runtime configuration utility.
 *
 * Values are read from window.APP_CONFIG (set via public/config.js at runtime)
 * with a fallback to build-time process.env variables.
 *
 * To change the API URL on the server without rebuilding:
 *   - Edit public/config.js on the server and refresh the page.
 */
const getConfig = {
    API_URL: window?.APP_CONFIG?.API_URL || process.env.REACT_APP_API_URL || '',
    BASE_URL: window?.APP_CONFIG?.BASE_URL || process.env.REACT_APP_BASE_URL || '',
}

export default getConfig;